<a
  *ngIf="isExternalPath(); else internalLinkTemplate"
  class="link-element typo-text-emphasis-1-mobile focus-link lg:typo-emphasis-3-desktop flex flex-row items-center py-4 text-[#002f6b] no-underline hover:opacity-70 lg:flex-col lg:px-2 lg:py-0 lg:text-center"
  [href]="path">
  <ng-container [ngTemplateOutlet]="quickLinkContent"></ng-container>
</a>

<ng-template #internalLinkTemplate>
  <a
    class="link-element typo-text-emphasis-1-mobile focus-link lg:typo-emphasis-3-desktop flex flex-row items-center py-4 text-[#002f6b] no-underline hover:opacity-70 lg:flex-col lg:px-2 lg:py-0 lg:text-center"
    [routerLink]="[path]">
    <ng-container [ngTemplateOutlet]="quickLinkContent"></ng-container>
  </a>
</ng-template>

<ng-template #quickLinkContent>
  <rd-shared-icon
    [ngClass]="[
      'mx-auto mb-3 mr-[30px] flex h-[60px] w-[60px] lg:mb-2.5 lg:mr-auto lg:h-[80px] lg:w-[80px]',
      iconClassName ?? ''
    ]"
    [iconSymbol]="iconSymbol"></rd-shared-icon>
  <span class="flex-grow">{{ text | translate }}</span>
</ng-template>
